import { render } from "./ResultadosCard.vue?vue&type=template&id=aad04be6&ts=true"
import script from "./ResultadosCard.vue?vue&type=script&lang=ts"
export * from "./ResultadosCard.vue?vue&type=script&lang=ts"

import "./ResultadosCard.vue?vue&type=style&index=0&id=aad04be6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__